var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav"},_vm._l((_vm.classList),function(item,index){return _c('div',{key:item.id,class:{ active: _vm.active === index },on:{"click":function($event){return _vm.changeActive(index, item.id)}}},[_vm._v("\n    "+_vm._s(item.name)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b323318","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabs.vue
// module id = null
// module chunks = 